<script setup lang="ts">
/**
 * Discord-Komponenten-Button (Message Components), aktuelles Refresh-Theme:
 * 10px-Radius, 36px Höhe, Emoji führend — Farben nach echten Screenshots
 * (Close = Danger-Rot, Assign = dunkles Sekundär-Grau).
 */
withDefaults(defineProps<{
  label: string
  variant?: 'primary' | 'secondary' | 'success' | 'danger'
  emoji?: string
  /** Link-Button (öffnet eine URL): Discord hängt das ↗-Glyph an */
  link?: boolean
}>(), {
  variant: 'secondary',
  emoji: undefined,
  link: false
})
</script>

<template>
  <span class="dc-btn" :class="`is-${variant}`">
    <span v-if="emoji" class="dc-btn-emoji" aria-hidden="true">{{ emoji }}</span>
    {{ label }}
    <svg
      v-if="link"
      class="dc-btn-link"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path d="M14 4h6v6M20 4l-9 9M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </span>
</template>

<style scoped>
.dc-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  font-family: var(--font-discord);
  font-size: 0.9rem;
  font-weight: 500;
  color: #fff;
  border-radius: var(--dc-radius-btn);
  padding: 8px 16px;
  min-height: 36px;
  cursor: default;
  user-select: none;
  transition: background var(--dur-fast) var(--ease-out);
}

.dc-btn.is-primary {
  background: var(--dc-blurple);
}

.dc-btn.is-primary:hover {
  background: var(--dc-blurple-hover);
}

.dc-btn.is-secondary {
  background: var(--dc-btn-secondary);
  border: 1px solid var(--dc-border-card);
}

.dc-btn.is-secondary:hover {
  background: var(--dc-btn-secondary-hover);
}

.dc-btn.is-success {
  background: var(--dc-btn-success);
}

.dc-btn.is-danger {
  background: var(--dc-red);
}

.dc-btn-emoji {
  font-size: 1rem;
  line-height: 1;
}

.dc-btn-link {
  margin-left: 2px;
  opacity: 0.9;
}
</style>
